import React from "react";
import { Button, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";

import { useAppApi } from "@/App";
import { ExportButton } from "@components/Common/Button";
import { RenderForm } from "@components/Forms/Render";
import { Awesome } from "@components/Helpers";
import { CommonCard, ListingCard } from "@components/Pages";
import { url_reverse } from "@components/Utils";

export default function ReportCloud() {
    const { t } = useTranslation();
    const params = useParams();
    const props = { header: t("Отчеты в облаке") };
    return params.id ? <Edit {...props} id={params.id} /> : <List {...props} />;
}

function List({ header }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:finstatements:report_cloud:list"));

    if (!apiData) return;

    return (
        <ListingCard header={header}>
            <Table hover responsive className="dmg-table">
                <thead>
                    <tr>
                        <th>{t("Название")}</th>
                        <th>{t("Разработчик")}</th>
                        <th>{t("Год")}</th>
                        <th>{t("Месяц")}</th>
                    </tr>
                </thead>
                <tbody>
                    {apiData.object_list?.map((o) => {
                        return (
                            <tr key={`object_list${o.id}`}>
                                <td>
                                    <Link to={url_reverse("finstatements:report_cloud:edit", { report_id: o.id })}>
                                        {o.filename}
                                    </Link>
                                </td>
                                <td>{o.developer?.name}</td>
                                <td>{o.year}</td>
                                <td>{o.month}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </Table>
        </ListingCard>
    );
}

function Edit({ id, header }) {
    const { t } = useTranslation();
    const { apiData } = useAppApi(url_reverse("api:finstatements:report_cloud:edit", { report_id: id }));

    if (!apiData) return;

    const buttons = (
        <>
            <Button variant="primary" type="submit">
                <Awesome type="cloud-upload" /> {t("Загрузить")}
            </Button>{" "}
            <ExportButton />
        </>
    );

    return (
        <CommonCard header={header}>
            <RenderForm backUrl={url_reverse("finstatements:report_cloud:list")} buttons={buttons} />
        </CommonCard>
    );
}
